export default "/images/c287fc8cc2875ef510c0d8867110fd0c.png";